"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var color = { type: "color" };
var fontSelect = {
  type: "select",
  options: [{ label: "20", value: "20px" }, { label: "25", value: "25px" }, { label: "30", value: "30px" }]
};
var textTransform = {
  type: "select",
  options: [{ label: "Capitalize", value: "capitalize" }, { label: "Uppercase", value: "uppercase" }, { label: "lowercase", value: "lowercase" }]
};
var fontWeight = {
  type: "select",
  options: [{ label: "Bold", value: "600" }, { label: "Medium", value: "400" }, { label: "Light", value: "200" }]
};
var radius = {
  type: "select",
  options: [{ label: "Square", value: "0%" }, { label: "Round", value: "10%" }, { label: "Circle", value: "50%" }]
};

var defaultProps = {
  componentName: "defaultProps",
  elementType: "",
  position: [],
  cms: {
    style: {
      footerBackground: "Background",
      textColor: "Font color",
      fontSize: "Font size",
      textTransform: "Text transform",
      iconSize: "Icon size",
      iconHoverColor: "Icons hover color"
    },
    content: {
      shortInfo1: "shortInfo1",
      shortInfo2: "shortInfo2",
      address: "Address",
      street: "Street",
      building: "Building",
      city: "City",
      country: "Country",
      followUs: "Followus"
    },
    media: {
      twitterUrl: "Twitter url",
      facebookUrl: "Facebook url",
      logo: "Brand logo url",
      altText: "Fallback text"
    }
  },
  styleType: {
    //editable part
    style: {
      footerBackground: _extends({}, color),
      textColor: _extends({}, color),
      fontSize: _extends({}, fontSelect),
      textTransform: _extends({}, textTransform),
      iconSize: _extends({}, fontSelect),
      iconHoverColor: _extends({}, color)
    },
    content: {
      shortInfo1: "input",
      shortInfo2: "input",
      address: "input",
      street: "input",
      building: "input",
      city: "input",
      country: "input",
      followUs: "input"
    },
    media: {
      facebookUrl: "input",
      twitterUrl: "input",
      logo: "input",
      altText: "input"
    }
  },
  props: _defineProperty({
    //editable part
    style: {
      footerBackground: "",
      textColor: "",
      fontSize: "",
      textTransform: "",
      iconSize: "25px",
      iconHoverColor: "red"
    },
    content: {
      shortInfo1: "<p>Explore unlimited opportunities of marketplace commerce with MARKETCUBE.io.</p>",
      shortInfo2: "<p>If you have any questions, feel free to email us at hello@marketcube.io</p>",
      address: "Address",
      street: "<p>77 New Cavendish Street</p>",
      building: "<p>The Harley Building</p>",
      city: "<p>London , W1W 6XB</p>",
      country: "<p>United Kingdom</p>",
      followUs: "Follow us"
    },
    media: {
      facebookUrl: "https://www.facebook.com",
      twitterUrl: "https://twitter.com/",
      logo: "https://elitemarketingpro.com/go/wp-content/uploads/2016/10/Dummy-logo-white.png",
      altText: "Brand image"
    }
  }, "media", {
    logo: "https://elitemarketingpro.com/go/wp-content/uploads/2016/10/Dummy-logo-white.png",
    altText: "Required"
  })
};

exports.default = defaultProps;